module.exports = __webpack_public_path__ + "img/products-pic.94ed7a97.png";